import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const InfantIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "InfantGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.1799 22C8.59566 22 5.67993 19.079 5.67993 15.4889V8.51112C5.67993 4.92102 8.59566 2 12.1799 2C15.7642 2 18.6799 4.92102 18.6799 8.51112V15.4889C18.6799 19.079 15.7642 22 12.1799 22ZM12.1799 3.10866C9.20638 3.10866 6.78677 5.53273 6.78677 8.51113V15.4889C6.78677 18.4673 9.20638 20.8914 12.1799 20.8914C15.1535 20.8914 17.5731 18.4673 17.5731 15.4889V8.51113C17.5731 5.53274 15.1535 3.10866 12.1799 3.10866Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.98462 18.1641C9.94354 18.1641 9.90193 18.1598 9.86032 18.1501C9.56254 18.0819 9.37608 17.7841 9.44471 17.4853C9.47012 17.3749 10.0976 14.7657 12.7469 14.2817C16.3052 13.6332 17.5731 11.2167 17.5731 9.17154C17.5731 8.86515 17.8206 8.61722 18.1265 8.61722C18.4324 8.61722 18.6799 8.86515 18.6799 9.17154C18.6799 12.3026 16.429 14.7375 12.9452 15.373C11.0055 15.7271 10.5283 17.7137 10.5235 17.7343C10.4645 17.9909 10.2365 18.1641 9.98462 18.1641Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.1805 15.5755C12.1475 15.5755 12.1145 15.5722 12.0805 15.5668C8.4319 14.901 5.67993 12.151 5.67993 9.17157C5.67993 8.86517 5.92745 8.61724 6.23335 8.61724C6.53925 8.61724 6.78677 8.86517 6.78677 9.17157C6.78677 11.286 8.84103 13.8487 12.2794 14.4755C12.5799 14.5307 12.7793 14.8198 12.7242 15.1208C12.6755 15.3882 12.4426 15.5755 12.1805 15.5755Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.1799 12.7368C9.94409 12.7368 8.12547 10.9146 8.12547 8.67569C8.12547 6.43674 9.94409 4.61463 12.1799 4.61463C14.4158 4.61463 16.2344 6.43674 16.2344 8.67569C16.2344 10.9146 14.4158 12.7368 12.1799 12.7368ZM12.1799 5.72328C10.5548 5.72328 9.23231 7.04738 9.23231 8.6757C9.23231 10.304 10.5548 11.6281 12.1799 11.6281C13.8051 11.6281 15.1276 10.304 15.1276 8.6757C15.1276 7.04738 13.8051 5.72328 12.1799 5.72328Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.9287 14.1908C14.6541 14.1908 14.4158 13.9862 14.3801 13.7068C14.3174 13.2121 14.092 12.7617 13.7364 12.4109C12.729 12.8439 11.6319 12.8439 10.6234 12.4109C10.2683 12.7617 10.0424 13.2121 9.97975 13.7068C9.94138 14.0111 9.66466 14.2287 9.36039 14.1865C9.0572 14.1475 8.84318 13.8703 8.88155 13.5661C8.99666 12.6642 9.4674 11.8631 10.2078 11.3109C10.3808 11.181 10.6115 11.1647 10.8002 11.2665C11.6946 11.7472 12.6674 11.7472 13.5597 11.2665C13.7494 11.1647 13.9802 11.181 14.152 11.3109C14.8924 11.8631 15.3632 12.6642 15.4783 13.5661C15.5167 13.8703 15.3026 14.1475 14.9994 14.1865C14.9757 14.1897 14.9519 14.1908 14.9287 14.1908Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.3929 8.41694C11.8405 8.41694 11.3411 8.15927 11.0142 7.67965C10.8418 7.42739 10.9061 7.08203 11.1585 6.9088C11.4125 6.73774 11.7557 6.8027 11.9275 7.05388C12.1464 7.37327 12.4777 7.32129 12.6555 7.26283C12.9755 7.15674 13.2192 6.88715 13.21 6.64788C13.1776 5.80557 12.3318 5.72979 12.1626 5.72329C11.8583 5.71139 11.6189 5.45588 11.6287 5.15165C11.6384 4.84743 11.8951 4.58867 12.1934 4.61465C12.902 4.63197 14.2569 5.07045 14.3158 6.60458C14.3444 7.34728 13.8045 8.04993 13.003 8.31518C12.7966 8.38447 12.5912 8.41694 12.3929 8.41694Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default InfantIcon;
